import React, { useState, useEffect } from "react";
import { classes } from "@bloomberg/media-ui-core";
import styles from "./updateHighlight.module.css";

type UpdateHighlightProps = {
  value: string | number;
};

const splitNumber = (previousValue: string, value: string) => {
  let direction = "";

  for (let i = 0; i < value.length; i++) {
    if (previousValue[i] === value[i]) {
      continue;
    } else if (previousValue[i] < value[i]) {
      direction = styles.green;
      break;
    } else {
      direction = styles.red;
      break;
    }
  }

  return direction;
};

export default function UpdateHighlight(props: UpdateHighlightProps) {
  const { value } = props;
  const [prevValue, setPrevValue] = useState("");
  const [direction, setDirection] = useState("");
  let formattedValue = value;

  useEffect(() => {
    if (typeof formattedValue === "number") {
      formattedValue = value.toString();
    }
    if (value !== prevValue) {
      setPrevValue(formattedValue);
    }

    // to handle first time load so values don't flash green
    if (prevValue.length === 0) {
      return;
    }

    if (prevValue.length < formattedValue.length) {
      setDirection(styles.green);
    } else if (prevValue.length > formattedValue.length) {
      setDirection(styles.red);
    } else {
      const directionalChange = splitNumber(prevValue, formattedValue);

      setDirection(directionalChange);
    }
  }, [value]);

  return (
    <span
      className={classes([styles.updateHighlight, direction])}
      onAnimationEnd={() => {
        setDirection(styles.updateHighlight);
      }}
    >
      {value}
    </span>
  );
}
